import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faBars, faChevronLeft, faChevronRight, faList, faShoppingBag, faShoppingBasket } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {
  faChevronLeft = faChevronLeft
  faShoppingBasket = faShoppingBag
  faChevronRight = faChevronRight
  main_nav = [
    {
      'label': 'Drone Prosumer',
      'link': '/catalog/prosumer'
    },

    {
      'label': 'Enterprise',
      'link': '/catalog/enterprise'
    },

    {
      'label': 'Store & Location',
      'link': '/location'
    },
    {
      'label': 'Mapping Service',
      'link': '/service'
    },
  ]

  prosummer = [
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/dc9e619bc6ac2bc59d17d0bcaff58b3f.webp',
      'title': ' Dji Mini',
      'desc': 'Mini to The Max',
      'link': '/catalog/view/Prosumer',
      'parrent': 1,
      'child': 7,
    },
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/9f9b989bf3469fd371376e08235724dc.webp',
      'title': 'Osmo',
      'desc': 'Mini to The Max',
      'link': '/catalog/view/Prosumer',
      'parrent': 2,
      'child': 31,
    },
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/df2248122303c9a90b7c65d2f7ae665d.webp',
      'title': 'Accessories',
      'desc': 'Mini to The Max',
      'link': '/catalog/view/Prosumer',
      'parrent': 1,
      'child': 13,
    },
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/6cbcec2f6e38efdccad35fa1c810e10d.webp',
      'title': ' Dji Mini',
      'desc': 'Mini to The Max',
      'link': '/catalog/view/Prosumer',
      'parrent': 1,
      'child': 7,
    }
  ]

  enterprise = [
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/89ebb24d2adc09cc7199829cff0ea712.webp',
      'title': ' Video Production',
      'desc': 'Solusi untuk video produksi yang lebih profesional',
      'link': '/catalog/enterprise',
      'parrent': 3,
      'child': 34,
    },
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/35ef95b27fe09834fbd4db547fc2e430.webp',
      'title': ' Enterprise',
      'desc': 'Produk untuk berbagai sektor industri',
      'link': '/catalog/enterprise',
      'parrent': 3,
      'child': 34,
    },
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/d8df55b75a20f2387cf90a9990006f41.webp',
      'title': ' Agriculture',
      'desc': 'Solusi khusus untuk bidang industri agrikultur',
      'link': '/catalog/enterprise',
      'parrent': 3,
      'child': 34,
    },

  ]



  isSticky: boolean;
  isShowCTA: boolean;
  regis_id: string;
  faBars = faBars
  @HostListener('window:scroll', ['$event'])
  doSomething(event) {
    this.isSticky = window.pageYOffset >= 20;

    this.isShowCTA = window.pageYOffset >= window.innerHeight;

  }



  constructor(

    private router: Router,
  ) {

  }

  ngOnInit(): void {
    // this.regis_id = localStorage.getItem("session_id");
  }
  navigateTo(item) {
    this.router.navigate(
      ['/catalog/view/Prosumer'],
      {
        queryParams: {
          parrent_id: item.parrent,
          child_id: item.child
        },
        queryParamsHandling: 'merge'
      }
    );

  }





}
